import styles from './style.module.css'

export const Form = ({children}: {children: any}) => {
  return (
    <div className={styles.btn_wrapper}>
      {children}
    </div>
  )
}

export default Form;
